import { IEvent } from "@Interfaces";
import { useUpsellListings } from "@Modules/eventPage/components/UpsellListings/utils/useUpsellListings";
import { isEmpty } from "@Utils";
import React from "react";

export const useOrderBumps = () => {
    const shouldRedirectToOffering = false;
    const upsellListingProps = useUpsellListings({ shouldRedirectToOffering });
    const { upsellListings } = upsellListingProps;

    const [showOrderBumps, setShowOrderBumps] = React.useState(false);
    const [upsellListingsBeforePayment, setupsellListingsBeforePayment] =
        React.useState<IEvent.IUpsellOffering[]>([]);

    React.useEffect(() => {
        if (!isEmpty(upsellListings) && isEmpty(upsellListingsBeforePayment)) {
            setupsellListingsBeforePayment(
                upsellListings.filter(
                    item => item.show_order_bump_before_payment
                )
            );
        }
    }, [upsellListings]);

    return {
        showOrderBumps,
        setShowOrderBumps,
        upsellListingProps: {
            ...upsellListingProps,
            upsellListings: upsellListingsBeforePayment,
        },
        shouldShowUpsellListings:
            !isEmpty(upsellListingsBeforePayment) && !showOrderBumps,
    };
};
